import React from 'react'
import { home_ongrid } from '../../Images'
import css from './HomePage.module.scss'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { battery_blank, battery_charged } from '../../Images/Icons'

const GridEnergyOnGrid = (props) => {
    const navigation = useNavigate();
    const dataConsumption = props.data.return.pv.active_power+props.data.return.grid.power/1000

    return (
        <div className={css.grid_ongrid}>
            <div className={css.image} style={{ position: 'relative' }}>
                {props.status == 'Trouble' ? <img src="/monitoring/assets/OnGrid.gif" style={{ filter: 'grayscale(100%)' }} /> : <img src="/monitoring/assets/OnGrid.gif"/>}
                {/* <img src="/monitoring/assets/OnGrid.gif" style={{ filter: 'grayscale(100%)' }} /> */}
            </div>
            <div className={css.home_value2} onClick={()=> navigation('/home/statistic')}>
                <div>PV</div>
                <div>
                    <label>{props.data.return.pv.active_power.toFixed(2)}</label>
                    <span> kW</span>
                </div>
            </div>  
            <div className={css.home_value3}>
                <div>
                    <div style={{clear:'both'}}>Consumption</div>
                    <label>{(dataConsumption.toFixed(3))} </label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value4}>
                <div>Grid</div>
                <div>
                    <label>{props.data.return.grid.power.toFixed(2)/1000}</label>
                    <span> kW</span>
                </div>
            </div>
        </div>
    )
}

export default GridEnergyOnGrid